import { UserRoles } from '../../../../../types/models/user/user.types';
import { FormItem } from '../../../Form/Form.types';
import { ChooseLoginModalFormSchema } from './ChooseLoginModalForm.types';

export const chooseLoginData: FormItem<ChooseLoginModalFormSchema>[][] = [
  [
    {
      name: 'userType',
      placeholder: 'Choisir une proposition',
      type: 'select',
      options: [
        {
          value: UserRoles.AcheteurPublic,
          label: 'Acheteur public',
        },
        {
          value: UserRoles.Entreprise,
          label: 'Entreprise',
        },
      ],
      required: true,
    },
  ],
];
